import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import {
    Button,
    LoadingSpinner,
    Modal,
    RowContainer,
    SelectList,
    toast,
    Typography,
} from '../../../common';
import { GetInstances } from '../../../../services/Api/instances/useApiInstances';
import { CreateSchedule } from '../../../../services/Api/schedules/useApiSchedules';

const NewScheduleModal = ({ closeForm }) => {
    const [isOptionsLoading, setIsOptionsLoading] = useState(true);
    const [instanceOptions, setInstanceOptions] = useState([]);
    const { push } = useHistory();

    useEffect(() => {
        setIsOptionsLoading(true);
        GetInstances()
            .then((response) => {
                if (response.data) {
                    setInstanceOptions(
                        response.data.map((instanceOption) => ({
                            label: `${instanceOption.company} ${instanceOption.project}`,
                            value: instanceOption.Id,
                        }))
                    );

                    setIsOptionsLoading(false);
                }
            })
            .catch((error) => {
                setIsOptionsLoading(false);
                toast.error();
            });
    }, []);

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
    } = useForm({
        mode: 'onChange',
    });

    const onSubmit = (data) => {
        const postData = {
            name: data.scheduleName,
            description: data.scheduleDescription,
            instanceId: data.instances.value,
        };

        CreateSchedule(postData).then((response) => {
            if (response && response?.status === 200) {
                toast.success('Schedule Created');
                const thisSchedule = response.data.find((ts) => ts.name === postData.name);
                push(`/schedules/${thisSchedule.id}`);
            } else {
                toast.error();
            }
        });
    };

    const inputClasses =
        'w-full text-sm placeholder-secondary flex-grow transition-all outline-none p-3 bg-gray-50 rounded-lg focus:ring focus:border-blue-light active:ring active:border-blue-royal';

    return (
        <Modal title="Create Schedule">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="pb-3 w-full">
                    <Typography variant="body2">
                        <label>Name*</label>
                        <input
                            placeholder="Name must be unique"
                            className={inputClasses}
                            {...register('scheduleName', { required: true })}
                        />
                        {errors.scheduleName && <p style={{ color: 'red' }}>Name is required.</p>}
                    </Typography>
                </div>

                <div className="pb-3">
                    <Typography variant="body2">
                        <label>Description*</label>
                        <input
                            placeholder="Add a short description"
                            className={inputClasses}
                            {...register('scheduleDescription', { required: true })}
                        />
                        {errors.scheduleDescription && (
                            <p style={{ color: 'red' }}>Description is required.</p>
                        )}
                    </Typography>
                </div>

                <div className="pb-3">
                    <Typography variant="body2">
                        <label>Project*</label>
                        {isOptionsLoading ? (
                            <LoadingSpinner />
                        ) : (
                            <Controller
                                name="instances"
                                isClearable
                                control={control}
                                render={({ field: { value, onChange } }) => (
                                    <SelectList
                                        options={instanceOptions}
                                        value={value}
                                        onChange={onChange}
                                    />
                                )}
                                {...register('instances', { required: true })}
                            />
                        )}
                        {errors.instances && (
                            <p style={{ color: 'red' }}>An Instance is required.</p>
                        )}
                    </Typography>
                </div>
                <RowContainer spacing="medium" className="justify-center">
                    <Button type="button" className="mr-4" onClick={() => closeForm && closeForm()}>
                        Cancel
                    </Button>
                    <Button type="submit">Create</Button>
                </RowContainer>
            </form>
        </Modal>
    );
};

export default NewScheduleModal;
